import React, { ReactNode } from "react";
import { IntlProvider } from "react-intl";

import caESMessages from "../../../../data/translations/ca-ES.json";
import deDEMessages from "../../../../data/translations/de-DE.json";
import enCAMessages from "../../../../data/translations/en-CA.json";
import enGBMessages from "../../../../data/translations/en-GB.json";
import enUSMessages from "../../../../data/translations/en-US.json";
import esESMessages from "../../../../data/translations/es-ES.json";
import frCAMessages from "../../../../data/translations/fr-CA.json";
import frFRMessages from "../../../../data/translations/fr-FR.json";
import itITMessages from "../../../../data/translations/it-IT.json";
import ptPTMessages from "../../../../data/translations/pt-PT.json";
import { Locale } from "../../../config/sites-and-locales";

// i18n HOSER - Add new locales here before rolling them out.
const allMessages: Record<Locale, {}> = {
  "ca-ES": caESMessages,
  "de-DE": deDEMessages,
  "en-CA": enCAMessages,
  "en-GB": enGBMessages,
  "en-US": enUSMessages,
  "es-ES": esESMessages,
  "fr-CA": frCAMessages,
  "fr-FR": frFRMessages,
  "it-IT": itITMessages,
  "pt-PT": ptPTMessages,
};

interface TranslationProviderProps {
  children: ReactNode;
  locale: Locale;
}

export function TranslationProvider({
  children,
  locale,
}: TranslationProviderProps) {
  const messages = allMessages[locale];

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
}
